<template>
  <omint-page>
    <Header name="Busca de rede" titleLabel="Busca de rede" />
    <omint-slider>
      <router-view />
    </omint-slider>
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";

export default {
  name: "Network-search",
  components: {
    Header
  }
};
</script>
